import { cx } from "shared/utils";
import {
  CSSProperties,
  MouseEventHandler,
  ReactNode,
  DragEventHandler
} from "react";
import { Link } from "react-router-dom";

interface CardProps {
  className?: string;
  children: ReactNode;
  onClick?: MouseEventHandler<HTMLDivElement>;
  linkTo?: string;
  style?: CSSProperties;
  draggable?: boolean;
  onDragStart?: DragEventHandler<HTMLDivElement>;
  onDragOver?: DragEventHandler<HTMLDivElement>;
  onDrop?: DragEventHandler<HTMLDivElement>;
}

export const Card = ({
  children,
  className,
  onClick,
  linkTo,
  style,
  draggable,
  onDragStart,
  onDragOver,
  onDrop
}: CardProps) => {
  const classNames = cx(
    "rounded-lg border border-alpha-100 bg-content-1000-inverted shadow-xs",
    onClick || linkTo
      ? "hover:border-alpha-200 hover:shadow-lg cursor-pointer"
      : "",
    className
  );

  if (linkTo)
    return (
      <Link to={linkTo} className={classNames} style={style}>
        <div>{children}</div>
      </Link>
    );

  return (
    <div
      className={classNames}
      onClick={onClick}
      style={style}
      draggable={draggable}
      onDragStart={onDragStart}
      onDragOver={onDragOver}
      onDrop={onDrop}
    >
      {children}
    </div>
  );
};
